import { render } from "./DonorFormProgress.vue?vue&type=template&id=b12b3446"
import script from "./DonorFormProgress.vue?vue&type=script&lang=js"
export * from "./DonorFormProgress.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__